import Configs from "../../config"
import React, { useEffect, useState } from "react"
import { MdDownload } from "react-icons/md"
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
} from "reactstrap"

const StaffModal = ({
  open,
  toggle,
  selectedStaff,
  roles,
  setSelectedStaff,
  viewOnly,
  onSubmit,
}) => {
  const [errors, setErrors] = useState({})

  useEffect(() => {
    setErrors({})
  }, [selectedStaff])

  const requiredFields = [
    "employeeId",
    "name",
    "email",
    "phone",
    "joiningDate",
    "designation",
    "roleId",
    "salary",
    // "profilePicture",

    "panCardNumber",
    // "panCard",
    "aadharCardNumber",
    // "aadharCard",

    "accountNumber",
    "ifscCode",
    "accountHolderName",
    "bankName",
  ]

  const handleChange = (field, value) => {
    setSelectedStaff(prev => ({ ...prev, [field]: value }))
    setErrors(prev => ({ ...prev, [field]: "" }))
  }

  const allowOnlyNumbers = e => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "")
  }

  const validate = () => {
    const newErrors = {}

    requiredFields.forEach(field => {
      if (!selectedStaff?.[field]) {
        newErrors[field] = "This field is required"
      }
    })

    if (!selectedStaff?.id && !selectedStaff?.password) {
      newErrors.password = "Password is Required"
    }

    if (
      selectedStaff?.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(selectedStaff.email)
    ) {
      newErrors.email = "Invalid email address"
    }

    if (selectedStaff?.phone?.length !== 10) {
      newErrors.phone = "Phone number must be 10 digits"
    }

    if (selectedStaff?.panCardNumber?.length !== 10) {
      newErrors.panCardNumber = "PanCard must be 10 digits"
    }

    if (selectedStaff?.aadharCardNumber?.length !== 12) {
      newErrors.aadharCardNumber = "Aadhaar must be 12 digits"
    }

    if (selectedStaff?.salary && Number(selectedStaff.salary) <= 0) {
      newErrors.salary = "Salary must be greater than 0"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = () => {
    if (!validate()) return
    onSubmit()
  }

  const renderError = field =>
    errors[field] && (
      <div className="invalid-feedback d-block">{errors[field]}</div>
    )

  const invalid = field => (errors[field] ? "is-invalid" : "")

  return (
    <Modal isOpen={open} centered fullscreen>
      <ModalHeader toggle={toggle}>
        {viewOnly
          ? "View Staff"
          : selectedStaff?.id
          ? "Edit Staff"
          : "Add Staff"}
      </ModalHeader>

      <ModalBody>
        {!viewOnly && (
          <ModalFooter className="p-0 pb-3">
            <Button className="btn-blue" onClick={handleSubmit}>
              Submit
            </Button>
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        )}
        <Form>
          {/* ================= PERSONAL DETAILS ================= */}
          <Card>
            <CardBody>
              <h4 className="fw-bold mb-3">Personal Details</h4>
              <Row>
                {/* Employee ID */}
                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      Employee ID <span className="text-danger">*</span>
                    </Label>
                    <Input
                      value={selectedStaff?.employeeId || ""}
                      onChange={e => handleChange("employeeId", e.target.value)}
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid(
                        "employeeId"
                      )}`}
                    />
                    {renderError("employeeId")}
                  </FormGroup>
                </Col>

                {/* Name */}
                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      value={selectedStaff?.name || ""}
                      onChange={e => handleChange("name", e.target.value)}
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid("name")}`}
                    />
                    {renderError("name")}
                  </FormGroup>
                </Col>

                {/* Email */}
                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      Email <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="email"
                      value={selectedStaff?.email || ""}
                      onChange={e => handleChange("email", e.target.value)}
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid("email")}`}
                    />
                    {renderError("email")}
                  </FormGroup>
                </Col>

                {/* Phone */}
                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      Phone <span className="text-danger">*</span>
                    </Label>
                    <Input
                      value={selectedStaff?.phone || ""}
                      maxLength={10}
                      onChange={e => {
                        allowOnlyNumbers(e)
                        handleChange("phone", e.target.value)
                      }}
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid("phone")}`}
                    />
                    {renderError("phone")}
                  </FormGroup>
                </Col>

                {/* Joining Date */}
                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      Joining Date <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="date"
                      value={selectedStaff?.joiningDate || ""}
                      onChange={e =>
                        handleChange("joiningDate", e.target.value)
                      }
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid(
                        "joiningDate"
                      )}`}
                    />
                    {renderError("joiningDate")}
                  </FormGroup>
                </Col>

                {/* Designation */}
                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      Designation <span className="text-danger">*</span>
                    </Label>
                    <Input
                      value={selectedStaff?.designation || ""}
                      onChange={e =>
                        handleChange("designation", e.target.value)
                      }
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid(
                        "designation"
                      )}`}
                    />
                    {renderError("designation")}
                  </FormGroup>
                </Col>

                {/* Role */}
                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      Role <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="select"
                      value={selectedStaff?.roleId || ""}
                      onChange={e => handleChange("roleId", e.target.value)}
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid("roleId")}`}
                    >
                      <option value="">Select Role</option>
                      {roles.map(r => (
                        <option
                          key={r.id}
                          value={r.id}
                          className="text-capitalize"
                        >
                          {r.name}
                        </option>
                      ))}
                    </Input>
                    {renderError("roleId")}
                  </FormGroup>
                </Col>

                {/* Salary */}
                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      Salary <span className="text-danger">*</span>
                    </Label>
                    <Input
                      value={selectedStaff?.salary || ""}
                      onChange={e => {
                        allowOnlyNumbers(e)
                        handleChange("salary", e.target.value)
                      }}
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid("salary")}`}
                    />
                    {renderError("salary")}
                  </FormGroup>
                </Col>

                {/* Profile Picture */}
                <Col xl={4}>
                  <FormGroup>
                    <Label>Profile Picture</Label>
                    <Input
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      onChange={e =>
                        handleChange("profilePicture", e.target.files[0])
                      }
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid(
                        "profilePicture"
                      )}`}
                    />
                    {selectedStaff?.profilePicture && (
                      <div className="d-flex align-items-center gap-2 mt-1">
                        <a
                          href={`${Configs.imageUrl}${selectedStaff.profilePicture}`}
                          className="text-muted small"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {selectedStaff.profilePicture}
                        </a>
                        <a
                          href={`${Configs.imageUrl}${selectedStaff.profilePicture}`}
                          download
                          title="Download"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <MdDownload size={18} color="#be9545" />
                        </a>
                      </div>
                    )}
                    {renderError("profilePicture")}
                  </FormGroup>
                </Col>

                {/* Password */}
                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      Password <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      onChange={e => handleChange("password", e.target.value)}
                      disabled={viewOnly}
                      placeholder="*********"
                      className={`form-control rounded-4 ${invalid(
                        "password"
                      )}`}
                    />
                    {renderError("password")}
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>

          {/* ================= DOCUMENTS ================= */}
          <Card>
            <CardBody>
              <h4 className="fw-bold mb-3">Employee Documents</h4>
              <Row>
                {/* PAN */}
                <Col xl={6}>
                  <FormGroup>
                    <Label>
                      PAN Number <span className="text-danger">*</span>
                    </Label>
                    <Input
                      value={selectedStaff?.panCardNumber || ""}
                      onChange={e =>
                        handleChange("panCardNumber", e.target.value)
                      }
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid(
                        "panCardNumber"
                      )}`}
                      maxLength={10}
                    />
                    {renderError("panCardNumber")}
                  </FormGroup>
                </Col>

                <Col xl={6}>
                  <FormGroup>
                    <Label>PAN File</Label>
                    <Input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={e => handleChange("panCard", e.target.files[0])}
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid("panCard")}`}
                    />
                    {selectedStaff?.panCard && (
                      <div className="d-flex align-items-center gap-2 mt-1">
                        <a
                          href={`${Configs.imageUrl}${selectedStaff.panCard}`}
                          className="text-muted small"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {selectedStaff.panCard}
                        </a>
                        <a
                          href={`${Configs.imageUrl}${selectedStaff.panCard}`}
                          download
                          title="Download"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <MdDownload size={18} color="#be9545" />
                        </a>
                      </div>
                    )}
                    {renderError("panCard")}
                  </FormGroup>
                </Col>

                {/* Aadhaar */}
                <Col xl={6}>
                  <FormGroup>
                    <Label>
                      Aadhaar Number <span className="text-danger">*</span>
                    </Label>
                    <Input
                      value={selectedStaff?.aadharCardNumber || ""}
                      onChange={e => {
                        allowOnlyNumbers(e)
                        handleChange("aadharCardNumber", e.target.value)
                      }}
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid(
                        "aadharCardNumber"
                      )}`}
                      maxLength={12}
                    />
                    {renderError("aadharCardNumber")}
                  </FormGroup>
                </Col>

                <Col xl={6}>
                  <FormGroup>
                    <Label>Aadhaar File</Label>
                    <Input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={e =>
                        handleChange("aadharCard", e.target.files[0])
                      }
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid(
                        "aadharCard"
                      )}`}
                    />
                    {selectedStaff?.aadharCard && (
                      <div className="d-flex align-items-center gap-2 mt-1">
                        <a
                          href={`${Configs.imageUrl}${selectedStaff.aadharCard}`}
                          className="text-muted small"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {selectedStaff.aadharCard}
                        </a>
                        <a
                          href={`${Configs.imageUrl}${selectedStaff.aadharCard}`}
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Download"
                        >
                          <MdDownload size={18} color="#be9545" />
                        </a>
                      </div>
                    )}
                    {renderError("aadharCard")}
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>

          {/* ================= BANK DETAILS ================= */}
          <Card>
            <CardBody>
              <h4 className="fw-bold mb-3">Bank Details</h4>
              <Row>
                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      Account Number <span className="text-danger">*</span>
                    </Label>
                    <Input
                      value={selectedStaff?.accountNumber || ""}
                      onChange={e => {
                        allowOnlyNumbers(e)
                        handleChange("accountNumber", e.target.value)
                      }}
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid(
                        "accountNumber"
                      )}`}
                    />
                    {renderError("accountNumber")}
                  </FormGroup>
                </Col>

                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      IFSC Code <span className="text-danger">*</span>
                    </Label>
                    <Input
                      value={selectedStaff?.ifscCode || ""}
                      onChange={e => handleChange("ifscCode", e.target.value)}
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid(
                        "ifscCode"
                      )}`}
                    />
                    {renderError("ifscCode")}
                  </FormGroup>
                </Col>

                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      Account Holder Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      value={selectedStaff?.accountHolderName || ""}
                      onChange={e =>
                        handleChange("accountHolderName", e.target.value)
                      }
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid(
                        "accountHolderName"
                      )}`}
                    />
                    {renderError("accountHolderName")}
                  </FormGroup>
                </Col>

                <Col xl={4}>
                  <FormGroup>
                    <Label>
                      Bank Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      value={selectedStaff?.bankName || ""}
                      onChange={e => handleChange("bankName", e.target.value)}
                      disabled={viewOnly}
                      className={`form-control rounded-4 ${invalid(
                        "bankName"
                      )}`}
                    />
                    {renderError("bankName")}
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Form>
      </ModalBody>
    </Modal>
  )
}

export default StaffModal
